import { PropsWithChildren } from 'react';
import { CheckoutSummaryProvider } from './CheckoutSummaryProvider';
import { SubscriptionContextBridge } from './SubscriptionContextBridge';

interface CheckoutContextAdapterProps {
  provider: 'checkout' | 'subscription';
}

export function CheckoutContextAdapter({
  children,
  provider,
}: PropsWithChildren<CheckoutContextAdapterProps>) {
  if (provider === 'checkout') {
    return <CheckoutSummaryProvider>{children}</CheckoutSummaryProvider>;
  }

  return <SubscriptionContextBridge>{children}</SubscriptionContextBridge>;
}
